import axios from 'core/network/interceptor';
import { GetApplicationsUrl } from './constants';

const GetApplicationsRequest = async (temp_worker_id: number) => {
    const response = await axios.get(GetApplicationsUrl(temp_worker_id));

    return response.data?.applications ?? [];
};

export { GetApplicationsRequest }
